import collectionReducer from '../collectionReducer';

export default collectionReducer({
    collectionActionName: 'DATAPOINTS',
    itemActionName: 'DATAPOINT',
});
